import * as Vue from 'vue/dist/vue.esm-bundler.js';
window.vue = Vue;

import loadVue from '@js/helpers/loadVue';
window.loadVue = loadVue;

import mitt from 'mitt';
window.emitter = mitt();

window.getModal = (modal) => emitter.emit(`get-${modal}-form`);